<div
  #frame
  class="comparison-slider__frame"
  (pointerdown)="onPointerDown($event)"
  (pointermove)="onPointerMove($event)"
  (pointerup)="onPointerUp()"
  (pointercancel)="onPointerUp()"
>
  <app-video-player
    class="comparison-slider__video"
    [videoSrc]="afterSrc()"
    [videoLabel]="afterLabel()"
  />

  <app-video-player
    class="comparison-slider__video comparison-slider__video--before"
    [style.clip-path]="beforeClip()"
    [videoSrc]="beforeSrc()"
    [videoLabel]="beforeClip()"
  />

  <div class="comparison-slider__gradient" aria-hidden="true"></div>

  <span
    class="comparison-slider__badge comparison-slider__badge--left type-caption-c3"
    [class.is-active]="position() > 50"
  >
    {{ beforeLabel() }}
  </span>
  <span
    class="comparison-slider__badge comparison-slider__badge--right type-caption-c3"
    [class.is-active]="position() < 50"
  >
    {{ afterLabel() }}
  </span>

  <div class="comparison-slider__divider" [style.left.%]="position()">
    <button
      class="comparison-slider__handle"
      type="button"
      role="slider"
      aria-label="Drag to compare the before and after images"
      aria-orientation="horizontal"
      aria-valuemin="0"
      aria-valuemax="100"
      [attr.aria-valuenow]="position()"
      [attr.aria-valuetext]="position() + '% revealing the before image'"
      (keydown)="onKeydown($event)"
    >
      <app-icon class="comparison-slider__icon" name="chevrons-left-right" />
    </button>
  </div>
</div>

<div class="comparison-slider__stacked">
  <figure class="comparison-slider__stacked-item">
    <app-video-player [videoSrc]="afterSrc()" [videoLabel]="afterLabel()" />

    <figcaption
      class="comparison-slider__stacked-badge comparison-slider__stacked-badge--before type-caption-c3"
    >
      {{ beforeLabel() }}
    </figcaption>
  </figure>

  <figure class="comparison-slider__stacked-item">
    <app-video-player [videoSrc]="beforeSrc()" [videoLabel]="beforeSrc()" />

    <figcaption
      class="comparison-slider__stacked-badge comparison-slider__stacked-badge--after type-caption-c3"
    >
      {{ afterLabel() }}
    </figcaption>
  </figure>
</div>
